module.exports = __webpack_public_path__ + "static/media/Mime_Jr._gaussian2.7d20506f.png";